import { useState } from "react";
import { getLoggedInUserInfo } from "../../helpers/api_helper";
import { useSelector } from "react-redux";

const useProfile = () => {
  const [userProfile] = useState<any>(getLoggedInUserInfo())
  const [loading] = useState<boolean>(userProfile ? false : true);

  return { userProfile, loading };
};

const useRole = () => {
  const { user } = useSelector((state: any) => state?.Login);

  const permissions = [
    {
      display_name: "ai_news",
      id: 7777,
      name: "ai_news"
    },
    {
      display_name: "my_news",
      id: 8888,
      name: "my_news"
    }, ...(
      !!user?.user?.configs?.boosting_news_flg ? [{
        display_name: "boosting_news",
        id: 9999,
        name: "boosting_news"
      }] : []
    )
  ];

  const userPermissions = permissions || [];
  return { userPermissions };
};

export { useProfile, useRole };
